/**
 * <relaunch-countdown data-target="<unix-ms>">
 * Renders a live DD : HH : MM : SS countdown. Reloads the page once the
 * target time is reached so server-rendered state (buy button, badges)
 * picks up the new availability.
 */
class RelaunchCountdown extends HTMLElement {
  connectedCallback() {
    const target = parseInt(this.dataset.target, 10);
    if (!Number.isFinite(target)) return;
    this.target = target;
    this.cells = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  tick() {
    const remaining = this.target - Date.now();
    if (remaining <= 0) {
      this.setAll(0, 0, 0, 0);
      this.classList.add('relaunch-countdown--done');
      clearInterval(this.interval);
      if (!this.reloaded) {
        this.reloaded = true;
        setTimeout(() => window.location.reload(), 800);
      }
      return;
    }
    const seconds = Math.floor(remaining / 1000) % 60;
    const minutes = Math.floor(remaining / (1000 * 60)) % 60;
    const hours = Math.floor(remaining / (1000 * 60 * 60)) % 24;
    const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
    this.setAll(days, hours, minutes, seconds);
  }

  setAll(d, h, m, s) {
    const pad = (n) => String(n).padStart(2, '0');
    if (this.cells.days) this.cells.days.textContent = pad(d);
    if (this.cells.hours) this.cells.hours.textContent = pad(h);
    if (this.cells.minutes) this.cells.minutes.textContent = pad(m);
    if (this.cells.seconds) this.cells.seconds.textContent = pad(s);
  }
}

if (!customElements.get('relaunch-countdown')) {
  customElements.define('relaunch-countdown', RelaunchCountdown);
}
